/**
 * Label Badge Component
 *
 * Displays version system labels (current, previous) as styled badges with an icon.
 * Used consistently across apps wherever version labels are displayed.
 */

import { GitBranch } from 'lucide-react';

import { Badge } from './badge';
import { cn } from '../lib/utils';

export interface LabelBadgeProps {
  label: 'current' | 'previous';
  className?: string;
}

/**
 * Badge component for version system labels
 *
 * @param label - The system label to display ('current' or 'previous')
 * @param className - Optional additional CSS classes
 */
export function LabelBadge({ label, className }: LabelBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn('bg-muted text-xs font-light capitalize', className)}
    >
      <GitBranch className="mr-1 h-3 w-3" />
      {label}
    </Badge>
  );
}
